/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ContratoDossieInfoAliases {
  CARD_1 = 'card-1',
  CARD_2 = 'card-2',
  CARD_CONTRACT = 'card-contract',
  CARD_PRODUCT = 'card-product',
  FETCH_CONTRATO = 'fetch-contrato',
  FIELD_0 = 'field-0',
  FIELD_1 = 'field-1',
  FIELD_2 = 'field-2',
  FIELD_3 = 'field-3',
  FIELD_4 = 'field-4',
  FIELD_5 = 'field-5',
  FIELD_6 = 'field-6',
  FIELD_7 = 'field-7',
  FIELD_ADDRESS = 'field-address',
  FIELD_CNPJ_CPF = 'field-cnpj-cpf',
  FIELD_CONTRACT = 'field-contract',
  FIELD_CONTRACT_DATE = 'field-contract-date',
  FIELD_LIST_CONTATO = 'field-list-contato',
  FIELD_LIST_PRODUTO = 'field-list-produto',
  FIELD_LIST_SCA = 'field-list-sca',
  FIELD_PRODUTO = 'field-produto',
  FIELD_QT_VIDAS = 'field-qt-vidas',
  FIELD_TIPO_CONTRATACAO = 'field-tipo-contratacao',
  FORM_0 = 'form-0',
  FORM_1 = 'form-1',
  FORM_2 = 'form-2',
  FORM_CONTRACT = 'form-contract',
  IMAGE_0 = 'image-0',
  LAYOUT_CONTRATO_DOSSIE_INFO = 'layout-contrato-dossie-info',
  PANEL_0 = 'panel-0',
  PANEL_1 = 'panel-1',
  PANEL_2 = 'panel-2',
  PANEL_CONTATO = 'panel-contato',
  PANEL_CONTRATO = 'panel-contrato',
  PANEL_DOSSIE = 'panel-dossie',
  PANEL_PRODUTO = 'panel-produto',
  PANEL_SCA = 'panel-sca',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
  TEXT_2 = 'text-2',
  TEXT_3 = 'text-3',
  TEXT_4 = 'text-4',
  TEXT_5 = 'text-5',
  TEXT_6 = 'text-6',
  TEXT_7 = 'text-7',
  TEXT_8 = 'text-8',
  TEXT_9 = 'text-9',
  TEXT_10 = 'text-10',
  TEXT_11 = 'text-11',
}
export { ContratoDossieInfoAliases };
